// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1fVql","title":"card_title__1jkV3","inActive":"card_inActive__FIRB2"};